module.exports = __webpack_public_path__ + "static/media/SM_horizontal.38dbacee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/SM_horizontal.svg
// module id = 180
// module chunks = 0